<template>
  <div
    class="comp-tool"
    :class="isShowMenu ? 'active' : ''"
    @mouseleave="hideMenu"
    @mouseenter="showMenu"
  >
    <div class="icon" @mouseleave="hideMenu" @mouseenter="showMenu">
      <svg-icon icon-class="tool"></svg-icon>
    </div>
    <div class="nav" v-show="isShowMenu">
      <a
        class="cell"
        v-for="(item, i) in linkList"
        :key="i"
        :href="item.link"
        :target="item.target"
        >{{ item.text }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ic-tool",
  data() {
    return {
      linkList: [
        { text: "产", target: "_blank", link: "/" },
        { text: "学", target: "_blank", link: "/" },
        { text: "研", target: "_blank", link: "/" },
        { text: "创", target: "_blank", link: "/" },
        { text: "转", target: "_blank", link: "/" }
      ],
      isShowMenu: false,
      timer: null
    };
  },
  methods: {
    hideMenu() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.isShowMenu = false;
      }, 150);
    },
    showMenu() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.isShowMenu = true;
      }, 150);
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-tool {
  position: fixed;
  bottom: 110px;
  right: 16px;
  z-index: 2;
  .icon {
    padding: 14px;
    background: white;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    width: 27px;
    height: 27px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .svg-icon {
      color: #cccccc;
      width: 27px;
      height: 27px;
      transition: color 0.3 ease;
    }
    &:hover {
      .svg-icon {
        color: $primary-color;
      }
    }
  }
  .nav {
    width: 56px;
    line-height: 56px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: absolute;
    bottom: 62px;
    right: 0;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    .cell {
      width: 56px;
      height: 56px;
      background: #fff;
      font-size: 20px;

      font-weight: 300;
      color: #666;
      &:hover {
        color: $primary-color;
        background: rgba(242, 243, 247, 1);
      }
    }
    .cell:first-child {
      border-radius: 8px 8px 0px 0px;
    }
    .cell:last-child {
      border-radius: 0 0 8px 8px;
    }
    .cell + .cell {
      border-top: 1px solid #ddd;
    }
  }
  &.active {
    .icon {
      .svg-icon {
        color: $primary-color;
      }
    }
  }
}
</style>
